import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useCallback } from 'react'
import { formatLocation } from '@companion-app/shared/ControlId.js'
import type { ControlLocation } from '@companion-app/shared/Model/Common.js'
import { Button } from '~/Components/Button'
import type { GenericConfirmModalRef } from '~/Components/GenericConfirmModal.js'
import { trpc, useMutationExt } from '~/Resources/TRPC'

export function ControlClearButton({
	location,
	resetModalRef,
}: {
	location: ControlLocation
	resetModalRef: React.MutableRefObject<GenericConfirmModalRef | null>
}): React.JSX.Element {
	const resetControlsMutation = useMutationExt(trpc.controls.resetControls.mutationOptions())

	const clearButton = useCallback(() => {
		resetModalRef.current?.show(
			`Clear button ${formatLocation(location)}`,
			`This will clear the style, feedbacks and all actions`,
			'Clear',
			() => {
				resetControlsMutation.mutateAsync({ locations: [location], newType: null }).catch((e) => {
					console.error(`Reset failed: ${e}`)
				})
			}
		)
	}, [resetControlsMutation, location, resetModalRef])

	return (
		<Button color="danger" onClick={clearButton} title="Clear Button" aria-label="Clear button">
			<FontAwesomeIcon icon={faTrashAlt} />
		</Button>
	)
}
